import React, { useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";

function TranslateScreen() {
    const [lang, setLang] = useState("ru");
    const [text, setText] = useState("");
    const [translation, setTranslation] = useState("");
    const { api_post } = useRequest();

    const translate = (ev) => {
        api_post(ev, "/dev/api/translate/", {
            params: { lang, text },
            then: (resp) => {
                if (resp.status === "ok") {
                    setTranslation(resp.result || "");
                } else {
                    alert(resp.message);
                }
            },
        });
    };

    return (
        <Card>
            <Card.Header>Переводы</Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Язык</Form.Label>
                            <Form.Control as="select" onChange={(e) => setLang(e.target.value)}>
                                <option value="ru">EN &gt; RU</option>
                                <option value="en">RU &gt; EN</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Текст</Form.Label>
                            <Form.Control as="textarea" value={text} onChange={(e) => setText(e.target.value)} />
                            <Form.Text className="text-muted">Текст РегИСтрО зависимый</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Перевод</Form.Label>
                            <Form.Control
                                as="textarea"
                                value={translation}
                                onChange={(e) => setTranslation(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <DevForm.Button variant="primary" name="translate" onClick={translate}>
                    Перевести
                </DevForm.Button>
            </Card.Body>
        </Card>
    );
}

export default TranslateScreen;
